module.exports = __webpack_public_path__ + "img/zulin.93926d9d.png";